import { gql } from '@apollo/client';

export const getCancellationPolicies = gql`query getCancellationPolicies {
  getCancellationPolicies {
    status
    errorMessage
    results{
      id
      policyName
      policyContent
      subTitle
      subContent
      content1
      content2
      content3
      priorDays
      dynamicCancellationContent{
        id
        cancellationId
        language
        policyName
        policyContent
        subTitle
        subContent
        content1
        content2
        content3
      }
    }
  }
}`

export const getCancellationPolicy = gql`query getCancellationPolicy ($id: Int!) {
  getCancellationPolicy (id: $id) {
    status
    errorMessage
    result{
      id
      policyName
      policyContent
      priorDays
      accommodationPriorCheckIn
      accommodationBeforeCheckIn
      accommodationDuringCheckIn
      guestFeePriorCheckIn
      guestFeeBeforeCheckIn
      guestFeeDuringCheckIn
      hostFeePriorCheckIn
      hostFeeBeforeCheckIn
      hostFeeDuringCheckIn
      subTitle
      subContent
      content1
      content2
      content3
      dynamicCancellationContent{
        id
        cancellationId
        language
        policyName
        policyContent
        subTitle
        subContent
        content1
        content2
        content3
      }
    }
  }
}`

export const updateCancelPolicy = gql`mutation updateCancelPolicy (
            $id: Int
            $policyName: String
            $policyContent: String
            $priorDays: Int
            $accommodationPriorCheckIn: Float
            $accommodationBeforeCheckIn: Float
            $accommodationDuringCheckIn: Float
            $guestFeePriorCheckIn: Float
            $guestFeeBeforeCheckIn: Float
            $guestFeeDuringCheckIn: Float
            $hostFeePriorCheckIn: Float
            $hostFeeBeforeCheckIn: Float
            $hostFeeDuringCheckIn: Float
            $subTitle: String
            $subContent: String
            $content1: String
            $content2: String
            $content3: String
            $language:String
            $dynamicCancellationPolicyContent:String

        ){
        updateCancelPolicy(
            id: $id
            policyName: $policyName
            policyContent: $policyContent
            priorDays: $priorDays
            accommodationPriorCheckIn: $accommodationPriorCheckIn
            accommodationBeforeCheckIn: $accommodationBeforeCheckIn
            accommodationDuringCheckIn: $accommodationDuringCheckIn
            guestFeePriorCheckIn: $guestFeePriorCheckIn
            guestFeeBeforeCheckIn: $guestFeeBeforeCheckIn
            guestFeeDuringCheckIn: $guestFeeDuringCheckIn
            hostFeePriorCheckIn: $hostFeePriorCheckIn
            hostFeeBeforeCheckIn: $hostFeeBeforeCheckIn
            hostFeeDuringCheckIn: $hostFeeDuringCheckIn
            subTitle: $subTitle
            subContent: $subContent
            content1: $content1
            content2: $content2
            content3: $content3
            language:$language
            dynamicCancellationPolicyContent:$dynamicCancellationPolicyContent
        ){
                status
                errorMessage
            }
        }`

export const updateCancellationInfo = gql`mutation (
            $id: Int,
            $description: String!,
            $dynamicCancellationInfo: String
        ) {
            updateCancellationInfo (
                id: $id,
                description: $description,
                dynamicCancellationInfo: $dynamicCancellationInfo
            ) {
                status
            }
        }`


export const getCancellationInfo = gql`
        query getCancellationInfo {
            getCancellationInfo {
                results {
                    id
                    description
                    dynamicCancellationInfo {
                        id
                        cancellationInfoId
                        language
                        description
                    }
                }
                status
                errorMessage
            }
        }
    `;